import store from '@/store'
// js 数字每三位数加一个逗号,
export function toThousands(num, decimals) {
  let newNum = +num
  if (isNaN(newNum)) {
    return num
  }
  let str = decimals !== undefined ? newNum.toFixed(decimals) : newNum.toString()
  const parts = str.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export function currencySymbol(value, currency = 'CNY', decimals) {
  if (value === undefined || value === null || value === '') return ''
  return (store.getters.currencySymbolMapping[currency] || '') + toThousands(value, decimals)
}
